import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/register')({
  beforeLoad: () => {
    const searchParams = new URL(window.location.href).searchParams;
    const promoCode = searchParams.get('promoCode');
    const email = searchParams.get('email');

    throw redirect({
      to: '/auth/signup',
      replace: true,
      search: {
        promoCode: promoCode ?? undefined,
        email: email ?? undefined,
      },
    });
  },
});
